module.exports = __webpack_public_path__ + "static/TiemposHeadlineWeb-Semibold-b76cfcf04235c9acc5342ac76ef2ef46.woff";